import { Button, Form, message, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import EmployeeForm from "./employee-form";
import useEmployees from "hooks/useEmployees";
///
const EditEmployeeModal = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state.modals
  );
  const {
    getEmployeeById,
    updateEmployee,
    employee,
    setEmployee,
    isLoading,
    error,
    setError,
  } = useEmployees();
  const [isSendForUpdate, setIsSendForUpdate] = useState(false);
  useEffect(() => {
    if (employee) {
      form.setFieldsValue({
        ...employee,
        entryDate: employee.entryDate ? dayjs(employee.entryDate) : null,
        exitDate: employee.exitDate ? dayjs(employee.exitDate) : null,
      });
    }
  }, [employee]);

  useEffect(() => {
    if (modalProps?.employeeId) {
      const fetchEmployeeData = async () => {
        try {
          const employeeData = await getEmployeeById(modalProps.employeeId);
          form.setFieldsValue({
            ...employeeData,
            entryDate: employeeData.entryDate
              ? dayjs(employeeData.entryDate)
              : null,
            exitDate: employeeData.exitDate
              ? dayjs(employeeData.exitDate)
              : null,
          });
        } catch (error) {
          console.error("Error fetching employee:", error);
        }
      };
      fetchEmployeeData();
    }
  }, [modalProps?.employeeId]);

  useEffect(() => {
    if (isSendForUpdate) {
      if (error) {
        message.error(t("employees.crud.form.error.edit"));
      } else {
        message.success(t("employees.crud.form.edit.success"));
        onClose();
      }
      setIsSendForUpdate(false);
    }
  }, [isSendForUpdate, error]);
  const open = isModalOpen && modalType === "edit_employee";

  const onSubmit = async (values) => {
    setError(null);
    setIsSendForUpdate(false);
    try {
      const formattedValues = {
        ...values,
        salary:
          values.salary === undefined || values.salary === null || values.salary === ""
            ? values.salary
            : Number(values.salary),
      };
      await updateEmployee(formattedValues, modalProps?.employeeId);
    } catch (error) {
      notification.error({
        message: t("employees.crud.form.error.edit"),
        description: error,
        role: "alert",
        duration: 3,
      });
    } finally {
      setIsSendForUpdate(true);
    }
  };

  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={
        <h4 style={{ textAlign: "center" }}>
          {t("employees.crud.form.title.modification")}
        </h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose} className="custom-btn-1">
          {t("employees.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="employee_form"
          disabled={isLoading}
          className="custom-btn-2"
        >
          {t("employees.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{
        content: { overflowY: "auto", maxHeight: "75vh", width: "100%" },
      }}
    >
      <EmployeeForm form={form} onSubmit={onSubmit} />
    </Modal>
  );
};

export default EditEmployeeModal;
